import React, { FocusEvent, Ref } from 'react';
import styled from 'styled-components';
import { MagnifyingGlassIcon, CrossIcon } from '../../assets';
import { theme, breakpoint } from '../../theme';

const InputWrapper = styled.div`
  display: flex;
  ${theme.typography.body['md']}
  background-color: ${theme.colors.primary.white};
  padding-left: ${theme.spacings[3].rem};
  padding-right: ${theme.spacings[3].rem};
  width: 436px;
  max-width: 436px;
  height: 40px;
  border-radius: 22px;

  ${breakpoint('md')`
        margin-left: ${theme.spacings[5].rem};
        margin-right: ${theme.spacings[4].rem};      
    `}

  ${breakpoint('lg')`
        margin-left: ${theme.spacings[4].rem};
        margin-right: ${theme.spacings[4].rem};      
    `}

    &:focus,
    &:focus-visible,
    &:focus-within {
    outline: 1px solid ${theme.colors.system.systemBlue};
  }
`;

const MagnifyingGlass = styled(MagnifyingGlassIcon)`
  fill: ${theme.colors.neutrals.solidGrays[2]};
  cursor: pointer;
  width: 18px;
`;

const Input = styled.input`
  ${theme.typography.uiText.md};
  appearance: none;
  background: none;
  border: none;
  outline: none !important;
  color: ${theme.colors.primary.graysGray};
  height: 40px;
  width: 100%;

  &:placeholder-shown {
    text-overflow: ellipsis;
  }
`;

const StyledCrossIcon = styled(CrossIcon)<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  fill: ${theme.colors.primary.graysGray};
  cursor: pointer;
  width: 18px;
  margin: 0 ${theme.spacings[2].rem};
`;

export type SearchBarProps = {
  placeholder?: string;
  isExpanded?: boolean;
  searchQuery?: string;
  onFocus: (e: FocusEvent<HTMLInputElement>) => void;
  onClick: (e: React.MouseEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearchBox?: () => void;
};

export const SearchBar = React.forwardRef<HTMLDivElement, SearchBarProps>(
  (
    {
      placeholder = 'What are you looking for?',
      isExpanded = false,
      searchQuery = '',
      onSearch,
      clearSearchBox,
      ...inputProps
    },
    ref: Ref<HTMLDivElement>
  ) => {
    return (
      <>
        <InputWrapper ref={ref}>
          <Input
            value={searchQuery}
            placeholder={placeholder}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            {...inputProps}
          />

          <StyledCrossIcon $isHidden={!isExpanded} onClick={clearSearchBox} />

          <MagnifyingGlass onClick={onSearch} />
        </InputWrapper>
      </>
    );
  }
);
